import { render, staticRenderFns } from "./PreorderSlide.vue?vue&type=template&id=2c28c50b&"
import script from "./PreorderSlide.vue?vue&type=script&lang=js&"
export * from "./PreorderSlide.vue?vue&type=script&lang=js&"
import style0 from "./PreorderSlide.vue?vue&type=style&index=0&id=2c28c50b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports